export class Paf {
    constructor({

        pafID = 0,
        orderID = 0,
        category = null,
        serviceNumber = null,
        accountNumber = null,
        currentServiceProvider = null,
        whitePagesListing = false,
        range = 0,
        billFileURL = null,
        comment = null
    } = {}) {
        this.pafID = pafID;
        this.orderID = orderID;
        this.category = category;
        this.serviceNumber = serviceNumber;
        this.accountNumber = accountNumber;
        this.currentServiceProvider = currentServiceProvider;
        this.whitePagesListing = whitePagesListing;
        this.range = range;
        this.billFileURL = billFileURL;
        this.comment = comment;
    }
}

export function createPaf(data) {
    return Object.freeze(new Paf(data));
}
